import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { keepPreviousData } from '@tanstack/react-query'

import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Typography } from '@gto/ui/typography'

import { useRedemptionsRedemptionOptionsGtoWizardList } from '@/api/gen'
import { Loader } from '@/components/loader'
import { SubscriptionKindEnum, SubscriptionLevelEnum } from '@/pages/rewards/constants'

import { GtoSubscriptionPlansSection } from './gto-subscription-plans-section'
import { GtoSubscriptionsSwitcher } from './gto-subscriptions-switcher'
import { SubscriptionLevelMobileSwitcher } from './subscription-level-mobile-switcher'

export const GtoSubscriptionsSection = () => {
  const { data, isFetching } = useRedemptionsRedemptionOptionsGtoWizardList(undefined, {
    query: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      placeholderData: keepPreviousData,
    },
  })
  const isSmAndLower = useMediaQuery('down', 'sm')

  const [activePlan, setActivePlan] = useState(SubscriptionLevelEnum.Premium)
  const [activeSubGroup, setActiveSubGroup] = useState(SubscriptionKindEnum['Cash Game'])

  const onChangeGroup = (type: SubscriptionKindEnum) => {
    setActiveSubGroup(type)
    setActivePlan(SubscriptionLevelEnum.Premium)
  }

  const items =
    data !== undefined && data.length > 0
      ? data
          // oxlint-disable-next-line typescript/no-unsafe-enum-comparison
          .filter((plan) => plan.subscription_type === activeSubGroup)
          .sort((a, b) => a.subscription_level - b.subscription_level)
      : []

  return (
    <div className="flex flex-col gap-8">
      <Typography
        component="h2"
        variant="h6"
      >
        <FormattedMessage id="edge.plansSection.title" />
      </Typography>

      <GtoSubscriptionsSwitcher
        active={activeSubGroup}
        onClick={onChangeGroup}
      />
      {isFetching ? (
        <Loader />
      ) : (
        <div className="flex flex-col gap-8">
          {isSmAndLower && (
            <SubscriptionLevelMobileSwitcher
              activeLevel={activePlan}
              levels={items}
              onClick={setActivePlan}
            />
          )}
          <GtoSubscriptionPlansSection
            plans={items.filter((plan) =>
              // oxlint-disable-next-line typescript/no-unsafe-enum-comparison
              isSmAndLower ? plan.subscription_level === activePlan : true,
            )}
          />
        </div>
      )}
    </div>
  )
}
